module.exports = __webpack_public_path__ + "img/dearGameBg.49482b57.png";